import { InputDateVariantType } from '../../../../../components/inputDateV2/types/inputDateVariantType';
import { getRegularStyles } from './variantStyles/regular';
export const getInputDateV2Styles = (FOUNDATIONS, FONT, SHADOWS) => ({
    [InputDateVariantType.REGULAR]: {
        ...getRegularStyles(FOUNDATIONS, FONT),
    },
});
//# sourceMappingURL=styles.js.map